// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/rollapp/metadata.proto (package dymensionxyz.dymension.rollapp, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message dymensionxyz.dymension.rollapp.RollappMetadata
 */
export class RollappMetadata extends Message<RollappMetadata> {
  /**
   * website is the rollapp website
   *
   * @generated from field: string website = 1;
   */
  website = "";

  /**
   * description is the rollapp description. should be limited to 512 chars
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * logo_url is the rollapp logo url
   *
   * @generated from field: string logo_url = 3;
   */
  logoUrl = "";

  /**
   * telegram is the rollapp telegram link
   *
   * @generated from field: string telegram = 4;
   */
  telegram = "";

  /**
   * x is the rollapp twitter link
   *
   * @generated from field: string x = 5;
   */
  x = "";

  /**
   * genesis_url has the genesis file
   *
   * @generated from field: string genesis_url = 6;
   */
  genesisUrl = "";

  /**
   * display_name is a non semantic name for displaying on gui etc. Size limited.
   *
   * @generated from field: string display_name = 7;
   */
  displayName = "";

  /**
   * tagline is a non semantic tagline/catch-phrase. Size limited.
   *
   * @generated from field: string tagline = 8;
   */
  tagline = "";

  /**
   * explorer_url is the rollapp's block explorer link
   *
   * @generated from field: string explorer_url = 9;
   */
  explorerUrl = "";

  /**
   * fee_denom is the base denom for fees
   *
   * @generated from field: dymensionxyz.dymension.rollapp.DenomMetadata fee_denom = 10;
   */
  feeDenom?: DenomMetadata;

  /**
   * Tags is a list of tags that can be used to filter rollapps.
   *
   * @generated from field: repeated string tags = 11;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<RollappMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.RollappMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "telegram", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "x", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "genesis_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tagline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "explorer_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "fee_denom", kind: "message", T: DenomMetadata },
    { no: 11, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollappMetadata {
    return new RollappMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollappMetadata {
    return new RollappMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollappMetadata {
    return new RollappMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: RollappMetadata | PlainMessage<RollappMetadata> | undefined, b: RollappMetadata | PlainMessage<RollappMetadata> | undefined): boolean {
    return proto3.util.equals(RollappMetadata, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.rollapp.DenomMetadata
 */
export class DenomMetadata extends Message<DenomMetadata> {
  /**
   * @generated from field: string display = 1;
   */
  display = "";

  /**
   * @generated from field: string base = 2;
   */
  base = "";

  /**
   * @generated from field: uint32 exponent = 3;
   */
  exponent = 0;

  constructor(data?: PartialMessage<DenomMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.rollapp.DenomMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "exponent", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DenomMetadata {
    return new DenomMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DenomMetadata {
    return new DenomMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DenomMetadata {
    return new DenomMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: DenomMetadata | PlainMessage<DenomMetadata> | undefined, b: DenomMetadata | PlainMessage<DenomMetadata> | undefined): boolean {
    return proto3.util.equals(DenomMetadata, a, b);
  }
}

